import { EMAIL_VERIFIED } from '../constants/errorCodes';
import auth, { DEFAULT_SIGNUP_VERSION, IConfirmSignUp } from '../services/auth';

export default async (formData: IConfirmSignUp, version: string = DEFAULT_SIGNUP_VERSION): Promise<string> => {
    try {
        await auth.confirmSignUp(formData, version);
        return EMAIL_VERIFIED;
    } catch (error) {
        if (error instanceof Error) {
            return error.message as string;
        }
        return 'UNKOWN';
    }
};
